import React from 'react'
import { sortableHandle } from 'react-sortable-hoc'


export const DragHandle = sortableHandle(() => <span>::</span>)